const $retailersList = $('.retailers .accounts');
const $noResults = $('.retailers .no-results');
const $accountsFeedback = $('.retailers .accounts-feedback');
const $accountsFeedbackSpinner = $accountsFeedback.find('.loading-spinner');
const $accountsFeedbackText = $accountsFeedback.find('.text');

(function setupRetailersBlock() {
    $('#retailer-use-location').click(sortByLocation);
})();

function showFeedbackError(message) {
    $accountsFeedbackText.html(message);
    $accountsFeedback.addClass('show');
    $accountsFeedbackSpinner.hide();
}

function trackEvent(event) {
    if (Array.isArray(window.dataLayer)) {
        window.dataLayer.push(event);
    }
}

function isDevEnvironment() {
    return window.location.hostname === 'easee.test';
}

function sortByLocation() {
    if (!navigator.geolocation) {
        console.error('Geolocation not supported.');
        showFeedbackError(pll_js_translations['Geolocation not supported.']);
        return;
    }

    function geoError(error) {
        console.error('Error loading geolocation', error);
        showFeedbackError(pll_js_translations['Geolocation not supported or allowed. Please search manually for your nearest location.']);
    }

    if (isDevEnvironment()) {
        geoSuccess({coords: {latitude: 58.7343343, longitude: 5.6483699}}, null, 'gps');
    } else {
        $accountsFeedbackText.html('Requesting location access...')
        $accountsFeedback.addClass('show');
        $accountsFeedbackSpinner.show();
        navigator.geolocation.getCurrentPosition(geoSuccess, geoError, {timeout: 15000});
    }
}

function geoSuccess(position, country = null, searchType = 'manual') {
    if (!position || !position.coords) {
        showFeedbackError(pll_js_translations['Geocoordinates not found. Please search manually for your nearest location.']);
        return;
    }

    if (!country) {
        reverseGeocodePosition(position);
        return;
    }

    const lat = position.coords.latitude;
    const lng = position.coords.longitude;

    let data = new FormData();
    data.append('action', 'retailers_search');
    data.append('country', country || '');
    data.append('lat', lat);
    data.append('lng', lng);

    $accountsFeedbackText.html(pll_js_translations['Finding retailers...']);
    $accountsFeedback.addClass('show');
    $accountsFeedbackSpinner.show();

    $retailersList.html('');
    $retailersList.removeClass('show');

    $.ajax({
        url: easee_scripts.ajax_url,
        type: 'POST',
        data: data,
        cache: false,
        processData: false,
        contentType: false,
        error: function (xhr, textStatus, errorThrown) {
            console.error('Retailer search failed', textStatus, errorThrown);
            showFeedbackError(pll_js_translations['An error occured'] + ': ' + (errorThrown || textStatus));
        },
        success: function (responseText) {
            $retailersList.html(responseText);

            if (responseText) {
                $noResults.removeClass('show')
                $retailersList.addClass('show');
            } else {
                $noResults.addClass('show')
                $retailersList.removeClass('show');
            }

            $accountsFeedback.removeClass('show');

            const results = $retailersList.find('.account').length;

            trackEvent({
                'event': 'search_installer',
                'search_type': searchType,
                'results': results,
            });

            $retailersList.find('.account h3').each(function(index, el) {
                trackEvent({
                    'event': 'view_installer',
                    'installer_name': el.innerText,
                    'position': index + 1
                });
            });

            $retailersList.find('.account a').click(function(e) {
                const $this = $(this);
                const heading = $this.find('h3')[0];
                const name = heading ? heading.innerText : null;
                const index = $this.parent().index();
                const hasLogo = $this.find('img.logo').length > 0;

                if (name && index > -1) {
                    trackEvent({
                        'event': 'select_installer',
                        'installer_name': name,
                        'position': index + 1,
                        'logo': hasLogo ? 'yes' : 'no',
                    });
                }
            })
        }
    });
}

function reverseGeocodePosition(position) {
    const lat = position.coords.latitude;
    const lng = position.coords.longitude;

    let data = new FormData();
    data.append('action', 'geocode_position');
    data.append('lat', lat);
    data.append('lng', lng);

    $accountsFeedbackText.html(pll_js_translations['Getting location...']);
    $accountsFeedback.addClass('show');
    $accountsFeedbackSpinner.show();

    $retailersList.html('');
    $retailersList.removeClass('show');

    $.ajax({
        url: easee_scripts.ajax_url,
        type: 'POST',
        data: data,
        cache: false,
        processData: false,
        contentType: false,
        dataType: 'json',
        error: function (xhr, textStatus, errorThrown) {
            console.error('Reverse geocoding failed', textStatus, errorThrown);
            showFeedbackError(pll_js_translations['Unable to find location. Please try searching manually.']);
        },
        success: function (results) {
            // The endpoint answers {"error": ...} (often with HTTP 200) when Google refuses the lookup
            const topHit = Array.isArray(results) ? results[0] : null;
            const components = topHit && Array.isArray(topHit['address_components']) ? topHit['address_components'] : [];
            const countryComponent = components.find(c => Array.isArray(c.types) && c.types.indexOf('country') !== -1);

            if (!countryComponent) {
                console.error('Reverse geocoding returned no country', results);
                showFeedbackError(pll_js_translations['Unable to find location. Please try searching manually.']);
                return;
            }

            $('#search-city-input').val(topHit['formatted_address'] || '');
            geoSuccess(position, countryComponent['short_name'], 'gps');
        }
    });
}

function initAutocomplete() {
    let $citySearchInput = $('.retailers .search-city').find('input');
    let options = window.googlePlacesCountryCode ? {
        componentRestrictions: {country: window.googlePlacesCountryCode }
    } : {};
    let autocomplete = new google.maps.places.Autocomplete($citySearchInput.get(0), options);
    autocomplete.addListener('place_changed', function() {
        let place = autocomplete.getPlace();
        if (place.geometry) {
            let lat = place.geometry.location.lat();
            let lng = place.geometry.location.lng();
            let country = null;
            let position = {
                coords: {
                    latitude: lat,
                    longitude: lng
                }
            }
            if (place['address_components']) {
                const countryComponent = place['address_components'].find(c => c.types.indexOf('country') !== -1);
                country = countryComponent ? countryComponent['short_name'] : null;
            }

            geoSuccess(position, country);
        }

        let $orderWrapper = $('.order-guide .order-wrapper');
        if($orderWrapper) {
            let $retailersHeight = $(".retailers").outerHeight();
            $orderWrapper.css("min-height", $retailersHeight + 500);
        }
    })
    return autocomplete;
}

window.initAutocomplete = initAutocomplete;
